import axios from 'axios';

export default axios.create({
  //baseURL: 'http://192.168.14.2:7199'
  //baseURL: 'http://120.138.7.130:7021'
  baseURL: 'https://amsapi.scriptindia.in'
  //baseURL: 'https://localhost:7199'
  //baseURL: 'https://demo.scriptindia.in:8049'
});